import { motion } from "framer-motion";
import { MessageCircle, Phone } from "lucide-react";
import { waUrl, PHONE, PHONE_TEL } from "../data";
import { WindowWatermark } from "./Logo";

export const Cta = () => {
  return (
    <section className="relative bg-ink overflow-hidden py-24 lg:py-28">
      <WindowWatermark className="absolute -left-16 top-1/2 -translate-y-1/2 h-[120%] w-auto text-white/[0.06]" />
      <div className="absolute inset-0 opacity-[0.05]" style={{ backgroundImage: "linear-gradient(#fff 1px, transparent 1px), linear-gradient(90deg, #fff 1px, transparent 1px)", backgroundSize: "80px 80px" }} />

      <div className="relative z-10 max-w-5xl mx-auto px-6 lg:px-10 text-center">
        <motion.h2
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="font-heading font-bold text-white text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-tight"
        >
          ¿Necesitas cambiar tus ventanas o instalar mosquiteras?
        </motion.h2>
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.1 }}
          className="mt-6 text-white/70 text-base md:text-lg leading-relaxed max-w-2xl mx-auto"
        >
          Pide tu presupuesto gratuito y sin compromiso. Respondemos rápidamente por
          teléfono o WhatsApp y trabajamos en toda Cantabria.
        </motion.p>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="mt-10 flex flex-col sm:flex-row gap-4 justify-center"
        >
          <a href={waUrl("Hola Ventanas Hondal, quiero un presupuesto gratuito y sin compromiso.")} target="_blank" rel="noopener noreferrer" data-testid="cta-whatsapp-button" className="inline-flex items-center justify-center gap-3 bg-[#25D366] text-white font-semibold px-8 py-4 hover:brightness-95 transition-[filter] duration-300">
            <MessageCircle size={20} /> Presupuesto por WhatsApp
          </a>
          <a href={`tel:${PHONE_TEL}`} data-testid="cta-phone-button" className="inline-flex items-center justify-center gap-3 bg-white text-ink font-semibold px-8 py-4 hover:bg-electric hover:text-white transition-colors duration-300">
            <Phone size={20} /> Llamar al {PHONE}
          </a>
        </motion.div>
      </div>
    </section>
  );
};
